import React, { useState } from 'react'

const AlertEmails = ({alertEmails, onAddEmail, onDeleteEmail}) => {
  const [alertEmail, setAlertEmail] = useState()

  const handleEmailAdded = () => {
    onAddEmail(alertEmail)
    setAlertEmail('')
  }

  return (
    <div className='col-lg-4 col-md-6 admin-alerts-emails'>
      <label>Email</label>
      <ul>
        { alertEmails && alertEmails.map((email, index) => {
          return (
            <li key={index}>
              <div className='form-group admin-alerts-input'>
                <a onClick={() => onDeleteEmail(email)} className='admin-alerts__minus'>—</a>
                <input className='form-control' type='text' value={email} disabled={true} />
              </div>
            </li>
          )
        })}
        <div className='form-group admin-alerts-input'>
          <input onChange={(e) => setAlertEmail(e.target.value)} value={alertEmail} className='form-control' type='text' />
          <button onClick={handleEmailAdded} className='btn btn-success mt-2'>Add</button>
        </div>
      </ul>
    </div>
  )
}

export default AlertEmails
